import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFileSignature,
    faUserMinus,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useManagePostRequest } from "../../../../../hooks/useManagePostRequest/useManagePostRequest";

import FormSelect from "../../../../../components/atoms/Select";
import FormDatePicker from "../../../../../components/atoms/DatePicker";
import { toast } from "react-toastify";
import PageTable from "../../../../../components/pageComponents/PageTable";
import useDidMountEffect from "../../../../../hooks/useDidMountEffect/useDidMountEffect";
import {
  handleFind,
  jsonNoEstaVacio,
  updateFiltersWithExtraData,
} from "../../../../../helper/utils";

import PageWrapper from "../../../../../components/pageComponents/PageWrapper";
import {
    cuadroRequerimientosCrearRequerimientoForVacanteAPI,
    cuadroRequerimientosEliminarAsignacionAPI,
    cuadroRequerimientosGetAsignadosCuadroSedeId,
    cuadroRequerimientosGetReporteAsignadosCuadroSedeIdAPI,
} from "../../../../../consumers/backendApisUrls";
import MensajeConfirmacionDesasignarModal from "../tableView/modales/MensajeConfirmacionDesasignarModal";
import ModalEnabled from "../../../../../components/modalComponents/ModalEnabled";
import {TooltipWrapper} from "../../../styledComponents/styledComponents";

const INIT_KEYS = {
  IdsCargos: "IdsCargos",
  IdsTipoContrato: "IdsTipoContrato",
  IdsGradoDesarrollo: "IdsGradoDesarrollo",
  IdsEtiqueta: "IdsEtiqueta",
};

const ETIQUETA_COLORS = {
  "Consol.": { bg: "#e8f5e9", color: "#2e7d32" },
  Consolidado: { bg: "#e8f5e9", color: "#2e7d32" },
  Logrado: { bg: "#e3f2fd", color: "#1565c0" },
  "En prog.": { bg: "#fff8e1", color: "#f57f17" },
  "En Proceso": { bg: "#fff8e1", color: "#f57f17" },
  Inicio: { bg: "#fce4ec", color: "#c62828" },
};

const formatFecha = (fechaStr) => {
  if (!fechaStr) return "—";
  const date = new Date(fechaStr);
  if (isNaN(date)) return "—";
  return date.toLocaleDateString("es-PE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const EtiquetaBadge = styled.span`
  background-color: ${({ bg }) => bg || "#f3e5f5"};
  color: ${({ color }) => color || "#6a1b9a"};
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`;

const DesempenoValue = styled.span`
  font-weight: 700;
  font-size: 13px;
  color: ${({ value }) =>
    value >= 90 ? "#2e7d32" : value >= 75 ? "#1565c0" : "#f57f17"};
`;

const TrasladoBadge = styled.span`
  display: inline-block;
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  background-color: #e3f2fd;
  color: #1565c0;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`;

const ColorDot = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background-color: ${({ color }) => color || "transparent"};
  margin-right: 6px;
  vertical-align: middle;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;


const tableStyles = `
  .listar-tbody,
  .listar-tbody tr,
  .listar-tbody td {
    overflow: visible !important;
  }
  .fecha-ingreso-header .description {
  height: auto !important;
  padding-top: 0 !important;
  margin: 0 !important;
  font-size: 12px !important;
  line-height: normal !important;
  transform: translateY(-2px);
  }

  .fecha-ingreso-header .modal-Filtros span.col-form-label {
  font-family: GothamLight !important;
  font-weight: 400 !important;
  }

  .fecha-ingreso-header .modal-Filtros input[type="date"] {
  font-family: GothamLight !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  }
  .modal-Filtros {
    position: fixed !important;
    top: auto !important;
    left: auto !important;
    z-index: 99999 !important;
    background: white !important;
    min-width: 200px !important;
    max-height: 300px !important;
    overflow-y: auto !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
    border-radius: 8px !important;
  }
`;

export default function CuadroRequerimientosListarAsignadosTab({
  idCuadroSede,
}) {
  const [executeManagePost] = useManagePostRequest();
  const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

  const [formValues, setFormValues] = useState({
    Items: [],
    ExtraData: {},
    filters: [],
    selectedFilters: {},
    SumatoriaBloques: 0,
    SumatoriaProfesores: 0,
  });
  const [allFilters, setAllFilters] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [isLoading, setIsLoading] = useState(true);
  const [fechaIngresoInicio, setFechaIngresoInicio] = useState(null);
  const [fechaIngresoFin, setFechaIngresoFin] = useState(null);

  const manageSearch = async () => {
    setIsLoading(true);
    await executeManagePost(
      cuadroRequerimientosGetAsignadosCuadroSedeId(),
      getPayload(),
      successManageSearchCallback,
    );
    setIsLoading(false);
  };

  const getPayload = () => ({
    IdCuadroSede: idCuadroSede,
    Criteria: searchCriteria,
    Page: paginator.CurrentPage,
    ...formValues.selectedFilters,
  });

  const successManageSearchCallback = ({ data }) => {
    const {
      Items,
      ExtraData,
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
      SumatoriaProfesores,
      SumatoriaBloques,
    } = data;
    setFormValues((lastData) => ({
      ...lastData,
      Items,
      ExtraData,
      SumatoriaProfesores,
      SumatoriaBloques,
    }));
    setPaginator({
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
      SumatoriaProfesores,
      SumatoriaBloques,
    });

    console.log(data);
  };

  const buildAllFiltersAndUpdateFilters = (items, extraData) => {
    setAllFilters((prev) => {
      const cargoMap = Object.fromEntries(
        (prev.find((f) => f.key === INIT_KEYS.IdsCargos)?.value ?? []).map(
          (o) => [o.Value, o.Text],
        ),
      );
      const tipoMap = Object.fromEntries(
        (
          prev.find((f) => f.key === INIT_KEYS.IdsTipoContrato)?.value ?? []
        ).map((o) => [o.Value, o.Text]),
      );
      const gradoMap = Object.fromEntries(
        (
          prev.find((f) => f.key === INIT_KEYS.IdsGradoDesarrollo)?.value ?? []
        ).map((o) => [o.Value, o.Text]),
      );
      const etiquetaMap = Object.fromEntries(
        (prev.find((f) => f.key === INIT_KEYS.IdsEtiqueta)?.value ?? []).map(
          (o) => [o.Value, o.Text],
        ),
      );

      items.forEach((item) => {
        if (item.IdCargo && item.Cargo) cargoMap[item.IdCargo] = item.Cargo;
        if (item.IdTipoContrato && item.TipoContrato)
          tipoMap[item.IdTipoContrato] = item.TipoContrato;
        if (item.IdGradoDesarrollo && item.GradoDesarrollo)
          gradoMap[item.IdGradoDesarrollo] = item.GradoDesarrollo;
        if (item.Etiqueta) etiquetaMap[item.Etiqueta] = item.Etiqueta;
      });

      const newAllFilters = [
        {
          key: INIT_KEYS.IdsCargos,
          value: Object.entries(cargoMap).map(([v, t]) => ({
            Value: Number(v),
            Text: t,
          })),
        },
        {
          key: INIT_KEYS.IdsTipoContrato,
          value: Object.entries(tipoMap).map(([v, t]) => ({
            Value: Number(v),
            Text: t,
          })),
        },
        {
          key: INIT_KEYS.IdsGradoDesarrollo,
          value: Object.entries(gradoMap).map(([v, t]) => ({
            Value: Number(v),
            Text: t,
          })),
        },
        {
          key: INIT_KEYS.IdsEtiqueta,
          value: Object.entries(etiquetaMap).map(([v, t]) => ({
            Value: v,
            Text: t,
          })),
        },
      ];

      if (jsonNoEstaVacio(extraData)) {
        updateFiltersWithExtraData(
          newAllFilters,
          extraData,
          handleUpdatedFilters,
        );
      }

      return newAllFilters;
    });
  };

  const handleUpdatedFilters = (res) =>
    setFormValues((lastData) => ({ ...lastData, filters: res }));

  const handleFilterSelected = (res, key) =>
    setFormValues((lastData) => ({
      ...lastData,
      selectedFilters: { ...lastData.selectedFilters, [key]: res },
    }));

  const searchByFechas = () => {
    if (!(fechaIngresoInicio && fechaIngresoFin)) {
      toast.warn("Debe ingresar ambas fechas");
      return;
    }

    setFormValues((lastData) => ({
      ...lastData,
      selectedFilters: {
        ...lastData.selectedFilters,
        FechaInicio: fechaIngresoInicio,
        FechaFin: fechaIngresoFin,
      },
    }));
  };

  const handleCleanSearch = () => {
    setFormValues((prev) => ({ ...prev, selectedFilters: {} }));
    setSearchCriteria("");
    setFechaIngresoInicio(null);
    setFechaIngresoFin(null);
  };

  const init = async () => {
    setIsLoading(true);
    try {
      await manageSearch();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, [idCuadroSede]);

  useDidMountEffect(() => {
    buildAllFiltersAndUpdateFilters(formValues.Items, formValues.ExtraData);
  }, [formValues.ExtraData]);

  useDidMountEffect(() => {
    manageSearch();
  }, [paginator.CurrentPage, formValues.selectedFilters]);


    const DesasignarBloques = async (idAsignacion) => {
        const api = cuadroRequerimientosEliminarAsignacionAPI(idAsignacion);
        const payload = {
        }
        await executeManagePost(api, payload, successDesasignarBloquesInitCallback);
    }

    const successDesasignarBloquesInitCallback = async ({data}) => {
        await init();
    }

    const crearRequerimiento = async (idAsignacion) => {
        const api = cuadroRequerimientosCrearRequerimientoForVacanteAPI(idAsignacion);
        const payload = {
        }
        await executeManagePost(api, payload, successCrearRequerimientoCallback);
    }

    const successCrearRequerimientoCallback = async ({data}) => {
        await init();
    }

  const descargarReporte = async () => {
    setIsLoading(true);
    await executeManagePost(
      cuadroRequerimientosGetReporteAsignadosCuadroSedeIdAPI(),
      getPayload(),
      ({ data }) => {
        const link = document.createElement("a");
        link.href = data.Data;
        link.click();
      },
      false,
      () => { toast.error("No se pudo generar reporte"); },
      false,
    );
    setIsLoading(false);
  };

  const HEADERS = [
    { col: "col-sm-1", label: "Info" },
    { col: "col-sm-1", label: "Código vacante" },
    { col: "col-sm-1", label: "Especialidad" },
    { col: "col-sm-1", label: "Nº Prof." },
    { col: "col-sm-1", label: "Bloques" },
    { col: "col-sm-1", label: "N° Documento" },
    { col: "col-sm-2", label: "Profesor / Asistente" },
    {
      col: "col-sm-1",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(formValues.filters, INIT_KEYS.IdsCargos)}
            description="Cargo"
            selectedOptions={
              formValues.selectedFilters?.[INIT_KEYS.IdsCargos] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, INIT_KEYS.IdsCargos)
            }
          />
        </div>
      ),
    },
    {
      col: "col-sm-2",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(formValues.filters, INIT_KEYS.IdsTipoContrato)}
            description="Tipo de Contrato"
            selectedOptions={
              formValues.selectedFilters?.[INIT_KEYS.IdsTipoContrato] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, INIT_KEYS.IdsTipoContrato)
            }
          />
        </div>
      ),
    },
    {
      col: "col-sm-1",
      label: (
          <div className="d-flex justify-content-center fecha-ingreso-header">
            <FormDatePicker
                description="Fecha Ingreso"
                fechaInicio={fechaIngresoInicio}
                fechaFin={fechaIngresoFin}
                setFechaInicio={setFechaIngresoInicio}
                setFechaFin={setFechaIngresoFin}
                searchByFechas={searchByFechas}
            />
          </div>
      ),
    },
    {
      col: "col-sm-1",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(
              formValues.filters,
              INIT_KEYS.IdsGradoDesarrollo,
            )}
            description="Grado"
            selectedOptions={
              formValues.selectedFilters?.[INIT_KEYS.IdsGradoDesarrollo] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, INIT_KEYS.IdsGradoDesarrollo)
            }
          />
        </div>
      ),
    },
    { col: "col-sm-1", label: "R. Porcent." },
    {
      col: "col-sm-1",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(formValues.filters, INIT_KEYS.IdsEtiqueta)}
            description="R. Final"
            selectedOptions={
              formValues.selectedFilters?.[INIT_KEYS.IdsEtiqueta] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, INIT_KEYS.IdsEtiqueta)
            }
          />
        </div>
      ),
    },
    { col: "col-sm-1", label: "Año de evaluación" },
    { col: "col-sm-1", label: "Acciones" },
  ];

  return (
    <>
        <ModalEnabled
            modalEnabled={modalEnabled}
            setModalEnabled={setModalEnabled}
            refreshPage={manageSearch}
        />
      <style>{tableStyles}</style>
      <PageWrapper isLoading={isLoading}>
        <div className="generic-buscador-container">
          <div className="filtros-left-section">
            <input
              type="text"
              className="generic-input-criterio-busqueda"
              placeholder="Buscar por Profesor / Asistente o DNI"
              value={searchCriteria}
              onChange={(e) => setSearchCriteria(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") manageSearch();
              }}
            />
            <button
              onClick={manageSearch}
              type="button"
              className="generic-button-buscador"
            >
              Buscar
            </button>
            <button
              onClick={descargarReporte}
              type="button"
              className="generic-button-buscador"
            >
              Descargar Reporte
            </button>
            <a className="clean-filters" onClick={handleCleanSearch}>
              Limpiar búsqueda
            </a>
          </div>
        </div>
        <div
          style={{
            minHeight: "500px",
            overflow: "visible",
            position: "relative",
            zIndex: 1,
          }}
        >
          <PageTable
            headers={HEADERS}
            paginator={paginator}
            setPaginator={setPaginator}
          >
            <tbody className="listar-tbody">
              {isLoading ? (
                <tr>
                  <td colSpan={14} className="text-center py-4">
                    Cargando...
                  </td>
                </tr>
              ) : formValues.Items.length === 0 ? (
                <tr>
                  <td colSpan={14} className="text-center py-4">
                    No se encontraron resultados.
                  </td>
                </tr>
              ) : (
                formValues.Items.map((row, idx) => (
                  <tr key={`${row.IdAsignacion}-${row.EsAsistente}-${idx}`}>
                    <td className="text-center">
                      {row?.MensajeTooltip !== "" && (
                          <TooltipWrapper message={row.MensajeTooltip}>
                              <FontAwesomeIcon icon={faInfoCircle} size="xs" />
                          </TooltipWrapper>
                      )}
                    </td>
                    <td className="text-center">
                      {row.CodigoVacante ?? "—"}
                    </td>
                    <td>
                      {row.Color && <ColorDot color={row.Color} />}
                      {row.Especialidad || "—"}
                    </td>

                    <td className="text-center">{row.Plaza ?? "—"}</td>                    
                    <td className="text-center">{row.NroHoras ?? "—"}</td>
                    <td className="text-center">{row.NumeroDocumento ?? ""}</td>
                    <td>
                      {row.EsVacante
                        ? row.EsAsistente
                          ? "Vacante AE"
                          : "Vacante profesor"
                        : row.NombreProfesor || "—"}
                      {!row.EsVacante && row.EsTrasladoProgramado && (
                        <TrasladoBadge
                          title={`Traslado programado para el ${formatFecha(row.FechaEjecucionTraslado)}`}
                        >
                          Traslado programado
                        </TrasladoBadge>
                      )}
                    </td>

                    <td className="text-center">{row.Cargo}</td>

                    <td className="text-center">{row.TipoContrato || "—"}</td>

                    <td className="text-center">
                      {formatFecha(row.FechaIngresoEmpresa)}
                    </td>

                    <td className="text-center">
                      {row.GradoDesarrollo || "—"}
                    </td>

                    <td className="text-center">
                      {row.DesempenoGeneral != null ? (
                        <DesempenoValue value={row.DesempenoGeneral}>
                          {row.DesempenoGeneral}
                        </DesempenoValue>
                      ) : (
                        <span style={{ color: "#bbb" }}>—</span>
                      )}
                    </td>

                    <td className="text-center">
                      {row.Etiqueta ? (
                        (() => {
                          const s = ETIQUETA_COLORS[row.Etiqueta] || null;
                          return (
                            <EtiquetaBadge bg={s?.bg} color={s?.color}>
                              {row.Etiqueta}
                            </EtiquetaBadge>
                          );
                        })()
                      ) : (
                        <span style={{ color: "#bbb" }}>—</span>
                      )}
                    </td>
                    {/* Año de evaluación */}
                    <td className="text-center">
                      {row.AnioEvaluacion || "—"}
                    </td>
                    <td className="text-center">
                        {row?.PuedeDesasignar &&
                            <FontAwesomeIcon
                                icon={faUserMinus}
                                title="Desasignar"
                                size="md"
                                style={{ marginLeft: "auto" }}
                                onClick=
                                    {(e) =>
                                    {
                                        if (e) e.preventDefault();
                                        setModalEnabled({
                                            isEnable: true,
                                            component: MensajeConfirmacionDesasignarModal,
                                            data: {idAsignacion: row?.IdAsignacion, DesasignarBloques:DesasignarBloques}
                                        })
                                    }
                                    }
                            />
                        }

                        {row?.MostrarOpcionCrearRequerimientoPersonal &&
                            <FontAwesomeIcon
                                icon={faFileSignature}
                                title="Crear Requerimiento Personal"
                                size="md"
                                style={{ cursor: "pointer", marginLeft: "5px"}}
                                onClick={async (e) => {
                                    if (e) e.preventDefault();
                                    await crearRequerimiento(row?.IdAsignacion);
                                }}
                            />
                        }

                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </PageTable>
        </div>
        {!isLoading && formValues.Items.length > 0 && (
          <div
            className="resumen-totales"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "0.25rem",
              padding: "0.75rem 1.5rem",
              backgroundColor: "#ffffff",
              borderTop: "1px solid #e0e0e0",
              marginTop: "0.5rem",
              fontSize: "0.9rem",
              fontWeight: 500,
              color: "#2c3e50",
            }}
          >
            <span>
              Total # bloques: <strong>{formValues.SumatoriaBloques}</strong>
            </span>
            <span>
              Total # de profesores:{" "}
              <strong>{formValues.SumatoriaProfesores}</strong>
            </span>
          </div>
        )}
      </PageWrapper>
    </>
  );
}
